import { render, staticRenderFns } from "./ImageLibraryPick.vue?vue&type=template&id=28860f84"
import script from "./ImageLibraryPick.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageLibraryPick.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports